import { observer } from 'mobx-react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ProgressSpinner } from 'primereact/progressspinner';
import React from 'react';
import { commaSeparatedNumbers } from '../../../../utils/commaSeparatedNumbers';
import { BootleByRoomDataInterface } from './bottlebyroom.types';
import classes from './bottlebyRoomCalculation.module.scss';

interface BootleByRoomScreenProps {
  roomData: BootleByRoomDataInterface[];
  loading: boolean;
}

const BootleByRoomTable: React.FC<BootleByRoomScreenProps> = ({ roomData, loading }) => {
  if (loading === true) {
    return (
      <div className={classes.loadingContainer}>
        <ProgressSpinner className={classes.spinner} />
        <div>Loading Bottle by Shift data...</div>
      </div>
    );
  }

  return (
    <div className={classes.bottleByRoomTableContainer}>
      <DataTable
        value={roomData}
        emptyMessage="No records found"
        className={classes.dataTable}
        rowClassName={() => classes.tableRow}
        resizableColumns
        scrollable
        scrollHeight="flex"
        loading={loading}
        columnResizeMode="expand"
      >
        <Column field="room" header="Room" className={classes.column} />
        <Column
          field="firstShiftBottles"
          header="First Shift Bottles"
          className={classes.column}
          body={row => commaSeparatedNumbers(row.firstShiftBottles)}
        />
        <Column field="firstShiftJobs" header="First Shift Jobs" className={classes.column} />
        <Column
          field="firstShiftInclude"
          header="Include"
          body={row => (row.firstShiftInclude ? 'Y' : 'N')}
          className={classes.column}
        />
        <Column
          field="secondShiftBottles"
          header="Second Shift Bottles"
          className={classes.column}
          body={row => commaSeparatedNumbers(row.secondShiftBottles)}
        />
        <Column field="secondShiftJobs" header="Second Shift Jobs" className={classes.column} />
        <Column
          field="secondShiftInclude"
          header="Include"
          body={row => (row.secondShiftInclude ? 'Y' : 'N')}
          className={classes.column}
        />
      </DataTable>
    </div>
  );
};

export default observer(BootleByRoomTable);
